import axios from "../axiosConfig";

const baseUrl = process.env.REACT_APP_NINJA_ADMIN_BASE_URL;

export const createProviderTool = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/create-provider-tool`;
    const data = await axios.post(url, body).then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const viewProviderTool = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/filter-provider-tool`;
    const data = await axios.post(url, body).then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};

export const editProviderTool = async (body) => {
  try {
    const url = `https://${baseUrl}/workflow-engine/$REALM_ID/$USER_ID/v1/execution/service/run/patch-provider-tool`;
    const data = await axios.post(url, body).then((res) => res);
    return data;
  } catch (error) {
    return error;
  }
};
